/* eslint-disable @typescript-eslint/camelcase */
import { AT, getShortCode } from '../constants/tripTypes';
import { SetFromPlace } from '../types';
import { isInternationalPage } from './commonUtils';
const cityTypes = ['locality', 'administrative_area_level_2'];
const airportTypes = ['airport'];
const { LOCATION_FETCH_URL, FETCH_LOCATION_URL_V3 } = process.env;

const getCityName = (addressComponents): string | null => {
  const types = [
    'locality',
    'administrative_area_level_2',
    'administrative_area_level_1'
  ];
  for (const addressComponent of addressComponents) {
    for (const componentType of addressComponent.types) {
      if (types.indexOf(componentType) >= 0) {
        return addressComponent.long_name;
      }
    }
  }
  return null;
};
export const getPlaceObject = async (
  placeId: string,
  travelFor = ''
): Promise<SetFromPlace> => {
  if (isInternationalPage() && travelFor && getShortCode(travelFor) === AT) {
    const results = await fetch(
      `${FETCH_LOCATION_URL_V3}?place_id=${placeId}`
    ).then(r => r.json());

    if (results) {
      return {
        address: results?.formatted_address,
        latitude: results?.latitude,
        longitude: results?.longitude,
        place_id: placeId,
        is_city: results?.is_city,
        is_airport: false,
        city: results?.city,
        country_code: results?.country_code
      };
    } else {
      return {
        address: null,
        latitude: null,
        longitude: null,
        place_id: placeId,
        is_city: null,
        is_airport: null,
        city: null
      };
    }
  } else {
    const { results } = await fetch(
      `${LOCATION_FETCH_URL}?place_id=${placeId}`
    ).then(r => r.json());
    if (results?.length > 0) {
      return {
        address: results[0]?.formatted_address,
        latitude: results[0]?.geometry?.location?.lat,
        longitude: results[0]?.geometry?.location?.lng,
        place_id: placeId,
        is_city: results[0]?.types?.some(type => cityTypes?.includes(type)),
        is_airport:
          results[0]?.type?.some(type => airportTypes?.includes(type)) ||
          (results[0]?.formatted_address || '')
            ?.toLowerCase()
            ?.includes('airport'),
        city: getCityName(results[0]?.address_components)
      };
    } else {
      return {
        address: null,
        latitude: null,
        longitude: null,
        place_id: placeId,
        is_city: null,
        is_airport: null,
        city: null
      };
    }
  }
};
